import React from 'react';
import './toastLoading.less';

class ToastLoadingComponent extends React.PureComponent {

    render () {
        let maskClassName = !this.props.mask ? '': 'mask';
        return (
        	this.props.show ?
            <div id="loading-toast-component-wrapper" className={maskClassName}>
				<div className="loading-icon" />
            </div>
				:''
        );
    }
}


export default ToastLoadingComponent;



// WEBPACK FOOTER //
// ./src/components/public/loading/toastLoadingComponent.js